import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AppSettings} from '../../../settings/app-settings';
import {HttpClient} from '@angular/common/http';
import {MItem} from '../model/m-item';

@Injectable()
export class MItemService {

  constructor(private http: HttpClient) {
  }

  public findAll(): Observable<MItem[]> {
    return this.http.get<MItem[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-item/find-all');
  }

  public findByBarcode(barcode: string): Observable<MItem> {
    return this.http.get<MItem>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-item/find-by-barcode/' + barcode);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/service/m-item/service/m-item.service.ts